import { render, staticRenderFns } from "./PUC.vue?vue&type=template&id=664ff716&scoped=true"
import script from "./PUC.vue?vue&type=script&lang=js"
export * from "./PUC.vue?vue&type=script&lang=js"
import style0 from "./PUC.vue?vue&type=style&index=0&id=664ff716&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664ff716",
  null
  
)

export default component.exports